import userTypes from '../modules/user/types';
import {trackUser, trackOutUser} from '~/misc/metrics';

const metricsLogger = (store) => nextDispatch => action => {
  if (action.error || action.pending) {
    nextDispatch(action);
    return;
  }

  if (action.type !== userTypes.LOGIN_FULL
      && action.type !== userTypes.SIGNUP_FULL
      && action.type !== userTypes.USER_FROMSTORAGE
      && action.type !== userTypes.LOGOUT) {
    nextDispatch(action);
    return;
  }

  nextDispatch(action);
  const user = store.getState().user;

  try {
    switch (action.type) {
      case userTypes.LOGOUT: {
        trackOutUser();
        break;
      }
      case userTypes.SIGNUP_FULL: {
        trackUser(user, true);
        break;
      }
      default:
        trackUser(user);
    }
  } catch (err) {
    console.error(err)
  }
};

export default metricsLogger;



// WEBPACK FOOTER //
// ./src/middlewares/metricsUserId.js